import React, { useEffect } from 'react';
import ToggleButton from 'react-toggle-button';
import { Tooltip } from '../Tooltip';

const colors = {
  activeThumb: {
    base: 'rgb(255, 255, 255)',
  },
  inactiveThumb: {
    base: 'rgb(255, 255, 255)',
  },
  active: {
    base: 'rgb(232, 116, 0)',
    hover: 'rgb(208, 112, 0)',
  },
  inactive: {
    base: 'rgb(114,114,114)',
  },
};

const thumb = { width: 12, height: 12, boxShadow: 'none' };

const track = { width: '100%', maxWidth: 28, height: 16 };

export const Toggler = ({
  className,
  label,
  value,
  name,
  onChange,
  simple,
  field,
  form,
  disabled,
  tooltip,
  createTermsField = false,
  ...rest
}) => {
  useEffect(() => {
    form.validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.values[field.name]]);

  return field ? (
    <div className={`${className}`}>
      {label ? (
        <label
          htmlFor={field.name}
          className="toggle-label d-flex align-items-center"
        >
          <ToggleButton
            id={field.name}
            name={field.name}
            inactiveLabel={false}
            activeLabel={false}
            value={field.value}
            thumbStyle={thumb}
            trackStyle={track}
            thumbAnimateRange={[2, 14]}
            colors={colors}
            onToggle={(toggleValue) => {
              if (!disabled) {
                form.setFieldValue(field.name, !toggleValue);
                if (createTermsField) {
                  form.setFieldValue(`${field.name}Termo`, label);
                }
              }
            }}
            disabled={disabled}
            {...rest}
          />
          <p
            className={`ts-14 
                ms-2 
                ${!simple && 'fw-bold'}
                ${simple && 'text-grey'}
                ${field.value && !disabled ? 'text-orange' : 'text-muted'}
             `}
          >
            {label}
            {tooltip && <Tooltip title={tooltip}>?</Tooltip>}
          </p>
        </label>
      ) : (
        <ToggleButton
          id={field.name}
          name={field.name}
          inactiveLabel={false}
          activeLabel={false}
          value={field.value || false}
          thumbStyle={thumb}
          trackStyle={track}
          thumbAnimateRange={[2, 14]}
          colors={colors}
          onToggle={(toggleValue) => {
            if (!disabled) {
              form.setFieldValue(field.name, !toggleValue);
            }
          }}
          disabled={disabled}
          {...rest}
        />
      )}
    </div>
  ) : (
    <label htmlFor={name} className="toggle-label d-flex align-items-center">
      <ToggleButton
        id={name}
        name={name}
        inactiveLabel={false}
        activeLabel={false}
        value={value}
        thumbStyle={thumb}
        trackStyle={track}
        thumbAnimateRange={[2, 14]}
        colors={colors}
        onToggle={(toggleValue) => {
          if (!disabled) {
            onChange(!toggleValue);
          }
        }}
        disabled={disabled}
        {...rest}
      />
      <p className={`ts-14 fw-bold text-${value ? 'orange' : 'muted'}`}>
        {label}
      </p>
    </label>
  );
};
